import React, { useState, useEffect } from 'react';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import AdminPage from './AdminPage';
import './App.css';
import { CloudTables } from '@cloudtables/react';
import { useUserData } from './useUserDataP2';

function App({ signOut, user }) {
  const { primaryOwnerID1, primaryOwnerID2, loading, Admin } = useUserData(user);

  let TblID = '';
  let TblIDEmail = '';

  let Season = 'SUMMER';

  if(Season === 'FALL') {
    TblID = '7a0cf73c-9b5f-11ee-b957-eff473c55a31';
    TblIDEmail = '373e86d8-9b86-11ee-966d-53564b4a9738';
  }else {
    TblID = '5838d6e4-9b5f-11ee-b957-93788dc544df';
    TblIDEmail = '48648836-9b86-11ee-966d-b3120495c9ea';
  }    

const tbl_url = "https://pe5lg5it79.cloudtables.io/loader/" + TblID + "/table/bs5"


  return (
    <header className="App-header">
    {loading ? (
      <div>Loading...</div>
    ) : (
      <CloudTables
      src={tbl_url}
      apiKey="hxGx5JMtcElhtjqre0Mly3xj"
    />
    )}
  </header>

  );
}

export default withAuthenticator(App);
